import { Reward } from './reward.interface';

export interface Offer {
    id: number;
    name: string;
    description: string;
    couponCode?: string;
    expireDate: Date;
    availableDate?: Date;
    imageUrl?: string;
    redeemInStore: boolean;
    redeemOnline: boolean;
    offerType: OfferType; // 'reward' | 'coupon' | 'notification'
    isRead: boolean;
    autoSelect?: boolean;
    discountChannel?: string;
    discountAmount?: number;
    storeNumbers?: string[];
    properties?: string;
    metaData?: string;
    redemptionDetails?: OfferRedemptionDetails;
    // pointsRequired: number;
    // reward: Reward;
}

export interface OfferRedemptionDetails {
    redemptionId: number;
    redemptionStatus: string;
    redemptionTrackingCode: string;
    redemptionMessage: string;
    redeemedValue: string | number;
    expiringAt: Date;
}

export enum OfferType {
    REWARD = 'reward',
    COUPON = 'coupon',
    NOTIFICATION = 'notification'
}
